module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('grouped-bar-chart', {
    attrs: {
      "data": _vm.data,
      "domain": _vm.domain,
      "margin": _vm.margin,
      "keys": _vm.keys,
      "tip-label": _vm.tipLabel
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Season Final Analysis")]), _vm._v(" "), _c('p', [_vm._v("\n      This chart visualizes teams by:\n    ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v(" IPL Final Appearences ")]), _vm._v(" "), _c('li', [_vm._v(" IPL Final Wins ")])]), _vm._v(" "), _c('small', [_vm._v("* Hover over the bars to see the actual values")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col col-6"
  }, [_c('h3', [_vm._v("Trivia")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n        Chennai Super Kings have the most final appearences at 6.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Kolkata Knight Riders have won 2 out of 2 finals.\n      ")]), _vm._v(" "), _c('li', [_vm._v("\n        Mumbai Indians, Kolkata Knight Riders and Chennai Super Kings have won\n        2 titles each, making them the most successful teams.\n      ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10073d47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/SeasonFinals.vue
// module id = 389
// module chunks = 1